export enum ExperimentValue {
  SERVICE_FEE_DISPLAY = 'service-fee-display',
}

export const TranslateEnvironment = {
  prd: 'production',
  stg: 'staging',
  loc: 'staging',
}
